import styled from "styled-components";

import { SectionContainer } from "../../clients-dashboard-style";

export const UnpaidContainer = styled(SectionContainer)`
  .button-container {
    margin-top: 30px;
    position: relative;
  }

  .info-button-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 50px;
  }
`;
